<template>
  <v-list class="sidebar__menu" dense>
    <v-list-item v-for="route in routes" :key="route.name">
      <span v-if="routeHasChildren(route)" :class="{'sidebar__link has-submenu': true, 'active': isActive(route)}">
        <v-icon>{{ route.meta.icon }}</v-icon>
        <div class="sidebar__submenu">
          <h4 class="sidebar__submenu-title">{{ route.meta.title }}</h4>
          <v-divider class="mt-4 mb-2" />
          <span v-for="route in route.children" :key="route.name">
            <router-link :to="route.path" class="sidebar__submenu-link">
              <span class="d-flex align-center text-truncate">
                <v-icon class="sidebar__submenu-icons" left>
                  {{ route.meta.icon }}
                </v-icon>
                <span class="body-1 font-weight-medium">
                  {{ route.meta.title }}
                </span>
              </span>
            </router-link>
          </span>
        </div>
      </span>
      <span v-else>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <router-link :to="route.path" class="sidebar__link">
              <v-icon v-bind="attrs" v-on="on">{{ route.meta.icon }}</v-icon>
            </router-link>
          </template>
          {{ route.meta.title }}
        </v-tooltip>
      </span>
    </v-list-item>
  </v-list>
</template>

<script>
import router from '@/router'
import { mapMutations } from 'vuex'

export default {
  name: 'SidebarMainMenu',

  computed: {
    currentRoute() {
      return this.$route
    }
  },

  methods: {
    ...mapMutations(['setIsMenuDrawerOpen']),

    mountRoutes() {
      Promise.resolve(localStorage.getItem('user_type')).then((role) => {
        this.router.map((route) => {
          if (route.meta && route.meta.icon && this.shouldShowForAustralianUsers(route) && this.shouldHideForCustomerWhoHasPartner(route)) {
            if (route.meta?.roles?.includes(role)) {
              this.routes.push(route)
            }
          }
        })
      })
    },

    shouldHideForCustomerWhoHasPartner(route) {
      const hasPartner = localStorage.getItem('has_partner')
      const invoiceRouter = route.name === 'invoices'

      if (hasPartner === 'true' && invoiceRouter) return false
      return true
    },

    shouldShowForAustralianUsers(route) {
      const isAustralian = localStorage.getItem('user_country') == 'AU'

      if (!isAustralian) return true

      return !route.meta.hideForAustralia
    },

    routeHasChildren(route) {
      return route.children && route.children.length
    },

    isActive(route) {
      if (this.routeHasChildren(route)) {
        return route.children.some((child) => {
          return this.currentRoute?.matched[0]?.name === child.meta.childrenOf
        })
      }
    }
  },

  data() {
    return {
      router: router.options.routes,
      routes: [],
    }
  },

  mounted() {
    this.mountRoutes()
  },
}
</script>
